import React, { ReactElement } from 'react';
import TableHeadInternal from '@mui/material/TableHead';
import FormatService from '../../services/format-service';
import useStylesTableHead from './table-head.styles';

const TableHead: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isHeader,
    isSubHeader,
    withNoPadding,
    withFixedCellsSize,
    withFixedCellsSizeCompressed,
    className,
    children,
  } = props;

  const { classes } = useStylesTableHead();

  const headerClassName: string | undefined = isHeader ? classes.tableHeadHeader : undefined;
  const subHeaderClassName: string | undefined = isSubHeader ? classes.tableHeadSubHeader : undefined;
  const fixedCellsSizeClassName: string | undefined = withFixedCellsSize ? classes.tableHeadFixedCellsSize : undefined;
  const fixedCellsSizeCompressedClassName: string | undefined = withFixedCellsSizeCompressed
    ? classes.tableHeadFixedCellsSizeCompressed : undefined;
  const noPaddingClassName: string | undefined = withNoPadding ? classes.tableHeadNoPadding : undefined;

  return (
    <TableHeadInternal
      classes={{
        root: FormatService.formatClassNames(
          headerClassName, subHeaderClassName, fixedCellsSizeClassName, fixedCellsSizeCompressedClassName,
          noPaddingClassName, className,
        ),
      }}
    >
      {children}
    </TableHeadInternal>
  );
});

export default TableHead;
